<template>
  <v-card
    v-if="urlList && fileData"
    class="d-flex flex-row align-center mb-5"
    color="primary"
    tile
    flat
  >
    <v-card color="primary" tile flat>
      <v-breadcrumbs :items="urlList">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
            class="text-capitalize"
            href="javascript:void(0)"
            @click="redirectTo(item.to)"
            :disabled="item.disabled"
          >
            <button></button>
            <span class="white--text">{{ item.text }}</span>
          </v-breadcrumbs-item>
        </template>
        <template v-slot:divider>
          <v-icon color="white">mdi-chevron-right</v-icon>
        </template>
      </v-breadcrumbs>
    </v-card>
    <v-card
      v-show="$vuetify.breakpoint.smAndUp"
      class="mx-4"
      color="white"
      height="40"
      width="1"
      tile
      flat
      rounded
    >
    </v-card>
    <v-card
      v-show="$vuetify.breakpoint.smAndUp"
      color="primary"
      class="mr-7"
      flat
    >
      <div class="white--text">Loan Number:</div>
      <div>
        <!-- <v-btn
          class="pa-0 ma-0"
          text
          dark
          small
          :to="{
            path: '/pipeline/loan-detail',
            query: { loanNumber: fileData.fileName },
          }"
        >
          {{ fileData.fileName }}
        </v-btn> -->
        <span class="white--text">
          {{ fileData.fileName }}
        </span>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              color="white"
              @click="copyToClipboard(fileData.fileName)"
              text
              icon
              x-small
            >
              <v-icon small>mdi-content-copy</v-icon>
            </v-btn>
          </template>
          <span>Copy</span>
        </v-tooltip>
      </div>
    </v-card>
    <v-card
      v-show="$vuetify.breakpoint.smAndUp"
      color="primary"
      class="mr-7"
      flat
    >
      <div class="white--text">Borrower Name:</div>
      <div class="white--text">
        <span v-if="fileData.applications">{{
          fileData.applications[0].borrower.lastAndFirst
        }}</span>
      </div>
    </v-card>
    <v-card
      v-show="$vuetify.breakpoint.smAndUp"
      color="primary"
      class="mr-7"
      flat
    >
      <div class="white--text">Loan Status:</div>
      <div class="white--text">
        <span v-if="fileData.status">{{ fileData.status.loanStatusName }}</span>
      </div>
    </v-card>

    <v-card
      v-show="$vuetify.breakpoint.smAndUp"
      color="primary"
      class="mr-7"
      flat
    >
      <div class="white--text">Property Address:</div>
      <span class="white--text">
        {{ fileData.subProp.fullAddress }}
      </span>
      <ExternalLinkModal :to="fileData.subProp.googleMap">
        <v-btn class="text-decoration-none" color="white" text icon x-small>
          <v-icon small>mdi-google-maps</v-icon>
        </v-btn>
      </ExternalLinkModal>
      <ExternalLinkModal :to="fileData.subProp.zillowMap">
        <v-btn class="text-decoration-none" color="white" text icon x-small>
          <v-icon>mdi-alpha-z-circle-outline</v-icon>
        </v-btn>
      </ExternalLinkModal>
    </v-card>
  </v-card>
  <v-skeleton-loader v-else type="image" height="70"></v-skeleton-loader>
</template>

<script>
import ExternalLinkModal from "@/components/ExternalLinkModal.vue";
import { common } from "@/mixins";

export default {
  name: "QuickNavigation",
  components: {
    ExternalLinkModal,
  },
  props: {
    fileData: Object,
    routeHistory: Object,
  },
  created() {
    if (this.routeHistory) {
      const pathArray = this.routeHistory.fullPath.split("/");
      const lastPath = pathArray[pathArray.length - 1];
      let urlBuilder = "";

      for (const path of pathArray) {
        if (path) {
          let isLast = path === lastPath;
          urlBuilder = `${urlBuilder}/${path}`;

          let urlModel = {
            text: path.replaceAll("-", " ").split("?")[0],
            to: urlBuilder,
            disabled: isLast,
          };

          if (urlModel.to.includes("loan-detail") && !isLast) {
            urlModel.to += `?loanNumber=${this.routeHistory.query.loanNumber}`;
          }

          this.urlList.push(urlModel);
        }
      }
    }
  },
  data() {
    return {
      urlList: [],
    };
  },
  methods: {
    redirectTo(link) {
      this.$router.push({ path: link });
    },
  },
  mixins: [common],
};
</script>
